export class ListResult<T extends Object> {
    constructor(
        public data: T[] = [],
        public totalCount: number = data.length,
    ) {}
}
